import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { DepreciationMaterialRecord, ExpendableMaterialRecord, Warehouse } from '@/types/Component';
import { toCamel } from 'snake-camel';

type Material = {
    id: string
    name: string;
    warehouseId: string;
    warehouseName: string;
}

@Component({
    components: {
        Modal
    }
})
export default class SelectExpendableMaterials extends Vue {
    private baseUrl = '/warehouses'
    private warehouses: Warehouse[] = []
    private initialWarehouse: Warehouse = {
        id: "",
        name: "",
        chemicals: [],
        fertilizers: [],
        depreciationMaterials: [],
        expendableMaterials: [],
        isHidden: false
    }
    private selectedWarehouse: Warehouse = this.initialWarehouse
    private displayMaterials: { id: string; name: string; }[] = []
    private selectedMaterials: Material[] = []
    private searchWord = ""
    private displayWarehouses: Warehouse[] = []

    @Prop()
    private value!: boolean

    @Prop({
        required: true
    })
    private preSelectItem!: ExpendableMaterialRecord[]

    @Emit('input')
    private input(value: boolean) {
        value
    }

    @Emit('close')
    private save() {
        return this.selectedMaterials.map(material => ({
            warehouseId: material.warehouseId,
            warehouseName: material.warehouseName,
            materialId: material.id,
            materialName: material.name,
        }))
    }

    @Emit('cancel')
    private cancel() {
        // 初期化処理
        this.searchWord = ""
        this.displayMaterials = []
        this.selectedMaterials = []
        this.selectedWarehouse = this.initialWarehouse
    }

    @Watch('value')
    private onOpenModal() {
        if (this.value) {
            this.searchWord = ""
            this.displayMaterials = []
            this.selectedMaterials = []
            this.displayWarehouses = []
            this.selectedWarehouse = this.initialWarehouse
            this.getWarehouses()
        }
    }

    get isModalVisible(): boolean {
        return this.value;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }

    private getWarehouses() {
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=false`).then(ret => {
            this.warehouses = this.displayWarehouses = (toCamel(ret) as { warehouses: Warehouse[] }).warehouses
            .filter(w => w.name?.trim() !== '未管理') // ← remove 未管理 warehouse
            .map(warehouse => ({
                id: warehouse.id,
                name: warehouse.name,
                chemicals: warehouse.chemicals,
                fertilizers: warehouse.fertilizers,
                depreciationMaterials: warehouse.depreciationMaterials,
                expendableMaterials: warehouse.expendableMaterials.map(material => ({
                    id: material.id,
                    name: material.name,
                    warehouseId: warehouse.id,
                    warehouseName: warehouse.name
                })),
                isHidden: warehouse.isHidden
            }))
            if (this.preSelectItem?.length) {
                console.log(this.preSelectItem)
                // 渡された農薬を選択済みにする
                this.selectedMaterials = this.preSelectItem.map(item => ({
                    id: item.materialId,
                    name: item.materialName,
                    warehouseId: item.warehouseId,
                    warehouseName: item.warehouseName
                }))

                // 最初に選択された倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.selectedMaterials[0]?.warehouseId) || this.initialWarehouse
                this.displayMaterials = this.selectedWarehouse.expendableMaterials
                console.log(this.selectedMaterials)
                console.log(this.displayMaterials)
            } else {
                // 先頭の倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses[0]
                this.displayMaterials = this.selectedWarehouse.expendableMaterials
            }
        })
    }

    private selectWarehouse(warehouse: Warehouse) {
        this.selectedWarehouse = warehouse
        this.displayMaterials = warehouse.expendableMaterials
        this.filteringMaterials()
    }

    private filteringMaterials() {
        this.displayMaterials = this.warehouses.find(warehouse => this.selectedWarehouse.id === warehouse.id)?.expendableMaterials.filter(material => material.name.indexOf(this.searchWord) > -1) || []
    }

    private search() {
        this.displayWarehouses = this.warehouses.filter(warehouse => warehouse.expendableMaterials.filter(material => material.name.indexOf(this.searchWord) > -1).length)
        this.filteringMaterials()
    }
}